import React from 'react'
import MentalHeathCaseStudies from './MentalHealthCaseStudies'
import CallToAction from '../../../../LandingSection/CallToAction'
import Footer from '../../../../Components/Footer'
import Header from '../../../../Components/Header'
import Challenge from './Challenge'
import OurSolution from './OurSolution'
import TechSolutions from './MentalHealthTechSolutions'
import { TimelineDemo } from './TimelineDemo'
import MentalHealthTechSolutions from './MentalHealthTechSolutions'

const MentalHealthCaseStudiesPage = () => {
  return (
    <>
      <Header bgColor="#121212"/>
       <MentalHeathCaseStudies></MentalHeathCaseStudies>
      <MentalHealthTechSolutions></MentalHealthTechSolutions>
      <Challenge></Challenge>
      <OurSolution></OurSolution>
      <CallToAction/>
      <Footer/>
    </>
  )
}

export default MentalHealthCaseStudiesPage